export const EVENT = {
    TestEvent: 'test_event',
    Refresh: 'refresh',
    DATA_NOCACHE_AUTH: 'datanocache_auth',
    GET_DATA_NOCACHE: 'get.datanocache',
    SINGLE_ODDS_SELECTED: 'single.odds.selected',
    ACCOUNT_BALANCE_RELOAD: 'ACCOUNT_BALANCE_RELOAD',
    MAX_PAYOUT_CALC: 'max.payout.calc',
    PAYOUT_CALC: 'payout.calc',
    WIN_RISK_CHANGE: 'win.risk.change',
    ODDS_FORMAT_CHANGE: 'odds.format.change',
    LANGUAGE_CHANGE: 'language_change',
    SOUND_TOGGLE: 'sound.toggle',
    ODDS_REFRESH: 'odds.refresh',
    ODDS_REFRESHED: 'odds.refreshed',
    CLASSIC_ON_PLACE_BET: 'classic.place.bet',
    CLASSIC_ODDS_REFRESH_COUNTDOWN: 'classic.odds.refresh.countdown',
    CLASSIC_ODDS_REFRESH_SPINNER: 'classic.odds.refresh.spinner',
    CLASSIC_ODDS_REFRESH_SPINNER_VIEW_OPTION: 'classic.odds.refresh.spinner.viewoption',
    CLASSIC_ODDS_RESET_EVENTS: 'classic.odds.reset.events',
    CLASSIC_ODDS_SORT_ORDER_CHANGE: 'classic.odds.sorts.change', // change Events sort order - no version is applied
    CLASSIC_ODDS_FORMAT_CHANGE: 'classic.odds.format.change', // change Odds Format - no version is applied
    CLASSIC_CLEAR_STAKE: 'classic.odds.stake.clear', // Clear all stake in Odds page
    CLASSIC_CLEAR_CHANGE: 'classic.click.button.clear',
    CLASSIC_CHANGE_MARKET: 'classic.market.change', // Change the Classic Sport Market (FULL_TIME, HALF_TIME, TEAM_TOTAL) - no version is applied
    CLASSIC_LOADED_TEASER: 'classic.loading.teaser',
    OPEN_TEASER_PAGE: 'open.teaser.page',
    UPDATE_VIEW: 'update.view',
    BETTER_ODDS_SETTINGS_CHANGE: 'better.odds.settings.change',
    MAXRISK_TOOLTIP_SETTINGS_CHANGE: 'maxrisk.tooltip.settings.change',
    MARKET_LINE_CHANGED: 'market.line.change',
    UPDATE_PERIODS_DESC: 'update.periods.desc',
    MULTIPLE_LOGIN: "multiple.login",
    // VS_BETSLIP_REFRESH_ODDS: 'vs.betslip.refresh.odds',
    // VS_BETSLIP_SUBMIT_BETS: 'vs.betslip.submit.bets',
    // VS_BETSLIP_CANCEL_BETS: 'vs.betslip.cancel.bets',
    // VS_BETSLIP_REMOVE_BET: 'vs.betslip.remove.bet',
    ErrorsHappenOnPage: 'errors_happen_on_page',
    EnableMaintenancePage: 'enable_maintenance_page',
    DisableMaintenancePage: 'disable_maintenance_page',
    ON_PLACE_BET: 'betting.odds.placebet',
    BODY_CENTER_LOADING: 'BODY_CENTER_LOADING',
    BODY_CENTER_LOADING_DONE: 'BODY_CENTER_LOADING_DONE',
    CLASSIC_PARLAY_CLEAR_KEEP_SELECTION: 'classic.parlay.clear.keep.selection',
    /**
     * Spinner Event
     */
    START_SPINNING: 'spinning.start',
    STOP_SPINNING: 'spinning.stop',
    API_SERVICE_ERROR: 'API_SERVICE_ERROR',
    /**
     * switch tab
     */
    SWITCH_MARKET_TAB: 'market.switch.tab',
    /**
     * Casino
     */
    CASINO_GAME_FILTER: 'casino.game.filter',
    LIVE_CASINO_GAME_FILTER: 'live.casino.game.filter',
    CASINO_OPEN_GAME: 'casino.open.game',
    LIVE_CASINO_OPEN_GAME: 'live.casino.open.game',
    REQUIRE_LOGIN: 'require.login',
    CSS_LOADED: 'css.loaded',
    RELOAD_IFORIUM_GAME: 'reload.iforium.game',
    CLOSE_CASINO_GAME_WINDOW: 'close.casino.game.window',
    CLOSE_LIVE_CASINO_GAME_WINDOW: 'close.live.casino.game.window',
    CASINO_UPDATE_FAVOURITES: 'casino.favourite.game.update',
    CASINO_ADD_FAVOURITES: 'casino.favourite.game.add',
    CASINO_GET_FAVOURITES: 'casino.favourite.game.get',
    REFRESH_DATA: 'refresh.data',
    ALERT_UPDATE_PLACEBET_INFO: 'alert.update.placebet.info',
    ALERT_CONFIRM_PLACEBET: 'alert.comfirm.placebet',
    ALERT_CONFIRM_HR_PLACEBET_PARLAY: 'alert.comfirm.hr.placebet.parlay',
    ALERT_CONFIRM_PLACEBET_PARLAY: 'alert.confirm.placebet.parlay',
    ALERT_CONFIRM_PLACEBET_TEASER: 'alert.confirm.placebet.teaser',
    FETCH_PENDING_BETS: 'fetch.pending.bets',
    EXECUTE_PLACE_SINGLE_BETS: 'execute.place.single.bets',
    EXECUTE_HR_PLACE_SINGLE_BETS: 'execute.hr.place.single.bets',
    SCROLL_TO_BOTTOM_AFTER_ADD_BET: 'scroll.to.bottom.after.add.bet',
    RENEW_TEASER_SELECTION: 'reset.teaser.selection',
    ALERT_CONFIRM_PLACEBET_VS_SINGLE: 'alert.comfirm.placebet.vs.single',
    EXECUTE_PLACE_VS_SINGLE_BETS: 'execute.place.vs.single.bets',
    ALERT_LIVE_SCORE_NOTIFY_OK: 'alert.live.sore.notify.ok',
    CLOSE_ALERT_REGISTRATION_SUCCESSFUL: 'close.alert.registration.successful',
    ALERT_LIVE_SCORE_NOTIFY_CANCEL: 'alert.live.sore.notify.cancel',
    ALERT_LIVE_SCORE_NOTIFY_REMIND: 'alert.live.sore.notify.remind',
    ALERT_CONFIRM_PLACEBET_VS_PARLAY: 'alert.comfirm.placebet.vs.parlay',
    EXECUTE_PLACE_VS_PARLAY_BETS: 'execute.place.vs.parlay.bets',
    ALERT_LOGIN_NOTIFY_OK:'alert.login.notify.ok',
    WINDOW_GO_TO_REGISTER_PAGE: 'window.goto.register.page',
    WINDOW_OPEN_PROFILE: 'window.open.profile',
    WINDOW_OPEN_DEPOSIT: 'window.open.deposit',
    WINDOW_OPEN_FUND_TRANSFER: 'window.open.fund.transfer',
    WINDOW_OPEN_MYBETS: 'window.open.mybets',
    WINDOW_OPEN_MESSAGES: 'window.open.messages',
    WINDOW_OPEN_ANNOUNCEMENTS: 'window.open.announcements',
    WINDOW_OPEN_STATEMENTS: 'window.open.statements',
    WINDOW_OPEN_RESULTS: 'window.open.results',
    WINDOW_OPEN_PREFERENCES: 'window.open.preferences',
    WINDOW_OPEN_WITHDRAWAL: 'window.open.withdrawal',
    WINDOW_OPEN_BALANCE: 'window.open.balance',
    GOTO_SPORTS_PAGE: 'goto.sports.page',
    SHOW_TITLE_TOOLTIP: 'show.title.tooltip',
    ALERT_CONFIRM_ATA_TRANSFER: 'alert.comfirm.ata.transfer',
    ATA_TRANSFER_SUCCESSFULLY: 'ata.transfer.successfully',
    CLOSE_COMPACT_VIEW_NOTIFY: 'close.compact.notify',
    CLOSE_NEW_BETSLIP_MOBILE_NOTIFY: 'close.new.betslip.notify',
    OPEN_NEW_BETSLIP_MOBILE_NOTIFY: 'open.new.betslip.notify',
    WINDOW_OPEN_BETTING_RULES: 'window.open.betting.rules',
    WINDOW_OPEN_TEASER: 'window.open.teaser',
    
    /**
     * Change password
     */
    ALERT_CHANGE_PASSWORD_SUCCESSFUL: "alert.change.password.successful",
    ALERT_CHANGE_PROFILE_SUCCESSFUL: "alert.change.profile.successful",
    ALERT_CHANGE_QUESTION_SUCCESSFUL: "alert.change.question.successful",
    ALERT_LOAD_SERCURITY_QUESTION_FAIL: "alert.load.question.fail",

    /**
     * Max Bet Setting BASE
     */
    UPDATE_MAX_BET_PREFERENCE_SETTING_BASE: "update.max.bet.preference.setting.base",

    /**
     * Use for B2B login by URL
     */
    B2B_OPEN_COMPACT_NOTIFY: "b2b.open.compact.notify",
    SCROLL_TO_LEADER_BOARD_TNC: "scroll.to.leader.board.tnc",
    EXPAND_TNC_LEADER_BOARD: "expand.tnc.leader.board",

    /**
     * Use for click FIND OUT MORE button
     */
    FIND_OUT_MORE: "find.out.more",
    
    /**
     * Use for click banner/image button in casino page
     */
    CLINK_CASINO_LINK: "click.casino.link",

    CLICK_LIVE_CASINO_LINK: "click.live.casino.link",
    CLEAR_LIVE_CASINO_URL: "clear.live.casino.url",
    CLEAR_CASINO_URL: "clear.casino.url"
}




// WEBPACK FOOTER //
// ./src/app/events/listEvents.js